import React, { useId } from "react";
import PropTypes from "prop-types";

const PostSaveIcon = ({ size = 22, className = "" }) => {
    const gradientId = useId();
    const fillId = `${gradientId}-post-save-fill`;
    const strokeId = `${gradientId}-post-save-stroke`;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            aria-hidden="true"
            className={className}
        >
            <defs>
                <radialGradient id={fillId} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11 11) scale(10)">
                    <stop stopColor="rgba(120, 248, 197, 0.32)" />
                    <stop offset="1" stopColor="rgba(82, 168, 255, 0)" />
                </radialGradient>
                <linearGradient id={strokeId} x1="4" y1="18" x2="18" y2="4" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#68F8C5" />
                    <stop offset="1" stopColor="#4FA8FF" />
                </linearGradient>
            </defs>
            <circle cx="11" cy="11" r="10" fill={`url(#${fillId})`} />
            <path
                d="M6 11.5L9.4 15L16 7.5"
                stroke={`url(#${strokeId})`}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

PostSaveIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};

PostSaveIcon.defaultProps = {
    size: 22,
    className: "",
};

export default PostSaveIcon;
